import React from 'react';

const MissionStatement = () => {
  return (
    <section className="py-16 bg-dark/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative">
          {/* Decorative accent lines */}
          <div className="absolute left-0 top-0 h-2 w-24 bg-accent"></div>
          <div className="absolute right-0 bottom-0 h-2 w-24 bg-accent"></div>
          
          {/* Content container with subtle border */}
          <div className="border border-light/10 rounded-lg bg-dark/80 backdrop-blur-sm py-14 px-8 md:px-12 shadow-xl mx-4 md:mx-12">
            <h2 className="text-2xl sm:text-3xl text-light font-bold text-center mb-8">Our Mission</h2>
            
            <div className="flex justify-center">
              <blockquote className="text-xl md:text-2xl text-light/90 italic max-w-4xl text-center leading-relaxed">
                <span className="text-accent text-4xl font-serif leading-none inline-block mr-2">"</span>
                To deliver precise, customized strategies with measurable impact, empowering organizations to innovate boldly, streamline operations, and achieve sustainable, long-term growth.
                <span className="text-accent text-4xl font-serif leading-none inline-block ml-2">"</span>
              </blockquote>
            </div>
            
            {/* Signature or attribution */}
            <div className="mt-8 flex justify-center">
              <p className="text-light/80 font-semibold">— Brad Wilde, Founder</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MissionStatement;